import _ from "lodash";
import { useEffect, useState } from "react";


function useLocalStorage<T>(key:string|null, initialValue:T, hydrate:(json:any)=>T = _.identity): [T, ReturnType<typeof useState<T>>[1]] {
    const readValue = () => {
        if (key === null) return initialValue
      if (typeof window === 'undefined') {
        return initialValue;
      }
  
      try {
        const item = window.localStorage.getItem(key);
        return item ? hydrate(JSON.parse(item)) : initialValue;
      } catch (error) {
        console.warn(`Error reading localStorage key "${key}":`, error);
        return initialValue;
      }
    };
  
    const [storedValue, setStoredValue] = useState<T>(readValue);
  
    useEffect(() => {
        if (key === null) return;
        try {
        const valueToStore =
            storedValue instanceof Function ? storedValue(storedValue) : storedValue;
        if (typeof window !== 'undefined') {
            window.localStorage.setItem(key, JSON.stringify(valueToStore));
        }
        } catch (error) {
        console.warn(`Error setting localStorage key "${key}":`, error);
        }
    }, [storedValue, key]);
  
    return [storedValue, setStoredValue as any];
  }
  
  export default useLocalStorage;

